module.exports = __webpack_public_path__ + "assets/img/egg_tart_active.7d46cc9b.png";